module.exports = __webpack_public_path__ + "img/LOGO-white.1227faf6.png";